export const getAccountIdFromPath = (): string | undefined => {
  const path = window.location.pathname;

  // Match Control Center "as" routes: /cc/as/:asAccount/:asUser/...
  const asAccountMatch = path.match(/\/cc\/as\/([^/]+)/);
  if (asAccountMatch) {
    return asAccountMatch[1];
  }

  return undefined;
};
